import { CatalogDto } from "../../models/generic/catalog.dto";

export enum Status {
    delete = 0,
    disabled = 1,
    active = 2,
    lockedPwd = 3,
    booked = 4
}
export class StatusHelper {
    static getStatusById(id: Status){
        let nameStatus = "";
        switch (id) {
            case 1:
                nameStatus = "Inactivo";
                break;        
            case 2:
                nameStatus = "Activo";
                break;
            case 3:
                nameStatus = "Bloqueado por contraseña errónea";
                break;
            case 4:
                nameStatus = "Reservado";
                break;
            default:
                nameStatus = "Eliminado";
                break;
        }
        return nameStatus;
    }
    static getStatusByName(name: string){
        let idStatus = 0;
        switch (name) {
            case "Inactivo":
                idStatus = 1;
                break;        
            case "Activo":
                idStatus = 2;
                break;
            case 'Bloqueado por contraseña errónea':
                idStatus = 3;
                break;
            case 'Reservado':
                idStatus = 4;
                break;
            default:
                idStatus = 0;//"Eliminado";
                break;
        }
        return idStatus;
    }
    static getListStatus(withZero?: boolean, withLocked?: boolean){
        let list: CatalogDto[] = [
            { catalogId: 1, catalogValue: "Inactivo" },
            { catalogId: 2, catalogValue: "Activo" }
        ];
        if(withLocked){
            list.push({ catalogId: 3, catalogValue: "Bloqueado por contraseña errónea" });
        }
        if (withZero) {
            list.push({ catalogId: 0, catalogValue: "Eliminado" })
        }
        return list;
    }
}